import src from "IMAGE";
export default { src, width: 711, height: 423, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAAAAABd+vKJAAAAOElEQVR42gEtANL/AOjk5O3q8OzjAOTm6O7n6uLhAOfr8Ovo6OnmAOjk8u7u7u7mAOfl7e3q7OflMjAka9sFZk0AAAAASUVORK5CYII="};
